const state = {
  selectedCountry: null, // string
  selectedCountryId: null, // number
  selectedCity: null, // string
  selectedMuseum: null, // string
  selectedMuseumId: null, // number
  selectedPaint: null, // Object
};

const mutations = {
  setCountry (state, value) {
    state.selectedCountry = value;
    state.selectedMuseum = null;
    state.selectedMuseumId = null;
  },
  setCountryId (state, value) {
    state.selectedCountryId = value;
  },
  setCity (state, value) {
    state.selectedCity = value;
  },
  setMuseum (state, value) {
    state.selectedMuseum = value;
  },
  setMuseumId (state, value) {
    state.selectedMuseumId = value;
  },
  setPaint (state, value) {
    state.selectedPaint = value;
    if (value !== null && value.country !== state.selectedCountry)
      state.selectedCountry = value.country;
  },
};

const getters = {
  getCountry: state => state.selectedCountry,
  getCountryId: state => state.selectedCountryId,
  getCity: state => state.selectedCity,
  getMuseum: state => state.selectedMuseum,
  getMuseumId: state => state.selectedMuseumId,
  getPaint: state => state.selectedPaint,
};

const actions = {
  setCountry ({commit}, value) {
    commit ('setCountry', value);
  },
  setCountryId ({commit}, value) {
    commit ('setCountryId', value);
  },
  setCity ({commit}, value) {
    commit ('setCity', value);
  },
  setMuseum ({commit}, value) {
    commit ('setMuseum', value);
  },
  setMuseumId ({commit}, value) {
    commit ('setMuseumId', value);
  },
  setPaint ({commit}, value) {
    commit ('setPaint', value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
